import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import './pages.css';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { resetPassword } = useAuth();

  useEffect(() => {
    const isVerified = localStorage.getItem('passwordVerified');
    const verifiedEmail = localStorage.getItem('verifiedEmail');
    
    if (isVerified && verifiedEmail) {
      // Pre-fill the email and skip the initial step if needed
      setEmail(verifiedEmail);
      
      // Clear the verification flags
      localStorage.removeItem('passwordVerified');
      localStorage.removeItem('verifiedEmail');
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    
    if (!email) {
      return setError('Please enter your email address');
    }

    try {
      setIsLoading(true);
      await resetPassword(email);
      setMessage('Check your inbox for further instructions');
      setEmail('');
    } catch (err) {
      setError(err.message || 'Failed to reset password. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-card">
        <div className="brand-header">
          <h1>Noureesh Foods</h1>
          <p className="tagline">Positional food from Noureesh Foods</p>
        </div>
        
        <div className="password-reset-box">
          <h2>Reset Your Password</h2>
          <p className="instruction-text">Enter your email to receive a reset link</p>
          
          {error && <div className="error-message">{error}</div>}
          {message && <div className="success-message">{message}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                required
              />
            </div>

            <button 
              type="submit" 
              className="reset-button"
              disabled={isLoading}
            >
              {isLoading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>
        </div>

        <div className="auth-links">
          <p>Remember your password? <Link to="/login">Log In</Link></p>
          <p>Don't have an account? <Link to="/signup">Sign Up</Link></p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
